module.exports = __webpack_public_path__ + "../resources/img/ic_spec_sheet.0f720f88.svg";